import React, { useEffect, useState } from "react";
import { Alert, TextField } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { Dialog, DialogActions, DialogContent, Typography, Divider, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../../reusableComponents/CustomButton";
import './splitPayment.css'
import useDynamicFields from "../../../../customHooks/useDynamicFields";
import PaymentDynamicForm from "./PaymentDynamicForm";
import { useAuth } from "../../../../context/API_Client";
import CustomDropdown from "../../../../reusableComponents/CustomDropdown";
import CreateRefundIcon from '../../../../../assets/svg/splitPayment/createRefund.svg'
import { formatAmount } from "../../../utils/utils";


const SPLIT_PAYMENT_INITIAL_STATE = { partner: "", partnerAmount: "", commission: "" }

function SplitPaymentRefundModal({ gridData, isAuthorizedPermission, details, toggleDialog, updateToggleDialog, val, remainingAmount, initiateVoidCaptureRefund, initiateVoidCaptureRefundError, updateInitiateVoidCaptureRefundError, reasonsToDisplay, reasonsToSend, currencyCode, merchantSetting }) {

    const [error, setError] = useState("");
    const [reason, setReason] = useState();
    const [methodInfo, setMethodInfo] = useState();
    const [remainingRefundAmount, setRemainingRefundAmount] = useState(0)
    const paymentDynamicField = useDynamicFields(SPLIT_PAYMENT_INITIAL_STATE);
    const [partnerList, setPartnerList] = useState([])
    const [otherReasonValue, setOtherReasonValue] = useState("");
    const IS_AGENT = merchantSetting?.refundReviewEnabled && !isAuthorizedPermission("REFUND_REVIEW_PAYMENT")
    const SUBMIT_BUTTON_TEXT = IS_AGENT ? "Raise Request" : "Submit"

    const handleSubmitSettlement = () => {
        let totalAmount = 0
        const splitSettlementInstructions = paymentDynamicField?.fields?.map(({ partner, commission, partnerAmount }) => {
            const payload = {
                subMerchantId: partner,
                subMerchantSettlementReference: uuidv4(),
                subMerchantSettlement: { amount: partnerAmount || 0, currencyCode },
                merchantSettlement: { amount: commission || 0, currencyCode }
            }
            totalAmount += Number(partnerAmount) + Number(commission);
            return payload
        });

        const finalPayload = {
            splitSettlementInstructions, money: {
                amount: totalAmount,
                currencyCode: gridData["authorisation.money.currencyCode"],
            },
            shopper: {
                email: gridData["basicDetails.shopper.email"],
            },
            refundReason: reason,
            customRefundReason: otherReasonValue,
        };
        initiateVoidCaptureRefund(finalPayload, "refunds", val, uuidv4())

    };

    const isButtonDisabled = () => {
        let isAllFieldsAreCorrect = paymentDynamicField?.fields?.every(({ partner, partnerAmount, commission }) => {
            if (!partner) return false;
            const amountZero = Number(partnerAmount) === 0;
            const commissionZero = Number(commission) === 0;
            return !(amountZero && commissionZero) && (amountZero || commissionZero || (partnerAmount > 0 && commission > 0));
        });
        return !reason || error || !isAllFieldsAreCorrect
    }

    useEffect(() => {
        setRemainingRefundAmount(remainingAmount)
    }, [remainingAmount])

    useEffect(() => {
        let formattedPartneredList = details?.authorisation?.splitSettlements.map(el => ({ title: el.subMerchantName, value: el.subMerchantId }))
        formattedPartneredList = formattedPartneredList.filter(el => el?.title?.toLowerCase() !== "aggregator")
        setPartnerList(formattedPartneredList)
    }, [])

    useEffect(() => {
        if (reasonsToSend?.length) {
            setReason(reasonsToSend[0])
        }
    }, [reasonsToSend])


    return (
        <Dialog
            open={toggleDialog}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                    borderRadius: "12px",
                    width: "822px",
                    maxWidth: "822px",
                    minHeight: "633px",
                    display: "flex",
                    justifyContent: "space-between",
                },
            }}
        >
            <div >
                <div className="card-header" style={{ padding: "24px 24px 0px 0px" }}>
                    <div className="card-header-content">
                        <div className="card-header-content-top">
                            <div className="card-header">
                                <div className="card-header-content">
                                    <div className="card-header-content-top" style={{ paddingLeft: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                                            <CreateRefundIcon />
                                            <Typography className="SemiboldTwenty">
                                                Create Refund
                                            </Typography>
                                        </div>
                                        <CloseIcon
                                            sx={{ width: "24px", height: "36px" }}
                                            className="icon"
                                            onClick={() => updateToggleDialog(false)}
                                        />
                                    </div>

                                    <Typography className="refund-info" style={{ color: "#010102B8", paddingLeft: "24px" }}>
                                        Refunds take 5-10 business days to appear on your customer’s
                                        bank statement. Please note that your processor will not
                                        return the original MDR charged on this transaction.
                                    </Typography>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ padding: "0 24px 0 24px" }} className="d-flex">
                    {details?.basicDetails?.context?.orderId && <div style={{ minWidth: "180px" }}>
                        <Typography className="labelSemiBold mb-2" style={{ color: "#01010299", margin: "0" }}>
                            Order ID
                        </Typography>
                        <Typography className="bodyB2SemiBold mb-2" style={{ color: "#010102B8", margin: "0" }}>
                            {details?.basicDetails?.context?.orderId}
                        </Typography>
                    </div>}
                    <div style={{ minWidth: "180px" }}>
                        <Typography className="labelSemiBold mb-2" style={{ color: "#01010299", margin: "0" }}>
                            Transaction ID
                        </Typography>
                        <Typography className="bodyB2SemiBold mb-2" style={{ color: "#010102B8", margin: "0" }}>
                            {details?.transactionId}
                        </Typography>
                    </div>
                </div>
                <div className="mt-1 mb-2">
                    <Divider />
                </div>

                <DialogContent className="card-content mt-3">
                    <div style={{ paddingLeft: "70px", gap: "10px" }} className="d-flex align-items-center ">
                        <div>

                            <Typography className="bodyB2RegularText mb-2" style={{ margin: "0" }}>
                                Reason for refund
                            </Typography>
                            <CustomDropdown
                                width={"430px"}
                                height={"38px"}
                                fontSize={"16px"}
                                optionsToSend={reasonsToSend}
                                optionsToDisplay={reasonsToDisplay}
                                updateSelect={(id, value) => setReason(value)}
                                dropDownId={"Refund"}
                                defaultValue={reasonsToDisplay?.length ? reasonsToDisplay[0] : ""}
                            />
                        </div>
                        {reason === "others" && (
                            <div className=" mt-0">
                                <Typography className="bodyB2RegularText mb-2" style={{ margin: "0" }}>
                                    Other Reason
                                </Typography>
                                <TextField
                                    sx={{ height: "38px", margin: 0, ".MuiInputBase-root": { width: "200px" } }}
                                    variant="outlined"
                                    placeholder="Other Reason"
                                    id="outlined-basic"
                                    size="small"
                                    onChange={(e) => setOtherReasonValue(e.target.value)}
                                />
                            </div>
                        )}
                    </div>

                    <div style={{ padding: "0 70px", marginTop: "30px" }}>
                        <div className="d-flex align-items-center " style={{ gap: "20px" }}>
                            <Typography className="bodyB2SemiBold mb-2" style={{ margin: "0", minWidth: "180px", width: "40%" }}>
                                Partner
                            </Typography>
                            <Typography className="bodyB2SemiBold mb-2" style={{ margin: "0", minWidth: "160px", width: "20%" }}>
                                Partner Amount
                            </Typography>
                            <Typography className="bodyB2SemiBold mb-2" style={{ margin: "0", minWidth: "160px", width: "20%" }}>
                                Commission
                            </Typography>

                        </div>
                        < div className="partnerFormContainer">
                            <PaymentDynamicForm initiateVoidCaptureRefundError={initiateVoidCaptureRefundError} partnerList={partnerList} paymentDynamicField={paymentDynamicField} selectedType={"FIXED"} totalPaymentAmount={remainingAmount} error={error} setError={setError} setRemainingAmount={setRemainingRefundAmount} initialState={SPLIT_PAYMENT_INITIAL_STATE} />
                        </div>
                    </div>
                </DialogContent>
            </div >

            <DialogActions className="d-flex align-items-center justify-content-between" style={{ padding: "20px 24px" }}>
                <div className="d-flex align-items-center" style={{ gap: "10px" }} >
                    <Typography className="labelSemibold " style={{ color: "#9E5707" }}>
                        Amount Remaining :
                    </Typography>
                    <Typography className="labelSemibold" style={{ fontSize: "20px" }} >
                        {currencyCode} {" "}
                        {formatAmount({ amount: remainingRefundAmount?.toFixed(2) })}
                    </Typography>
                </div>
                <div className="d-flex " style={{ gap: "20px" }}>

                    <CustomButton text={"Cancel"} variant={"outlined"} type={"secondary"} onClick={() => updateToggleDialog(false)} />
                    <CustomButton text={SUBMIT_BUTTON_TEXT} variant={"contained"} disabled={isButtonDisabled()} onClick={handleSubmitSettlement} type={"secondary"} />
                </div>
            </DialogActions>
        </Dialog >
    )
}

export default SplitPaymentRefundModal